import { ReactComponent as BarcodeSVG } from "images/Barcode.svg"
import { fmobile, fresponsive } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function BarcodeTopper({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) {
	return (
		<TopBar className={className}>
			<Barcode />
			{children}
		</TopBar>
	)
}

const TopBar = styled.div`
	${textStyles.kicker2}
	${fresponsive(css`
		color: ${colors.grey3};
		display: flex;
		align-items: center;
		gap: 10px;
		padding-bottom: 10px;
		margin-bottom: 35px;
	`)}

  ${fmobile(css`
		margin-bottom: 30px;
	`)}

  border-bottom: 1px solid ${colors.grey1};
`

const Barcode = styled(BarcodeSVG)`
	path {
		fill: ${colors.grey3};
	}

	${fresponsive(css`
		height: 18px;
	`)}
`
